/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_TimeInputs */



/**
* | output |
* | --- |
* | "Match by Time" |
*
* @param {Metadata_Merge_Match_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_time = /** @type {((inputs?: Metadata_Merge_Match_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Match par heure")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spiel nach Zeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Partita per tempo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Матч по времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Coincidencia por tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按时间匹配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時間による試合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय के अनुसार मैच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correspondência por tempo")
	return /** @type {LocalizedString} */ ("Match by Time")
});